import { Patient } from "@/src/data/allTypes";
import { getAge, getName } from "@/src/utils/utils";
import { getAntecedentsText } from "./textGenerationUtils";

export async function generateOrientationLetterHtml({
    patient,
  }: {
    patient: Patient;
  }) {
    let antecedentsText = await getAntecedentsText({ patient });
    return `Cher confrère,
    permettez-moi de vous adresser le/la patient(e) ${getName(
      patient
    )}, âgé(e) de ${getAge(patient)}, ${
      antecedentsText
        ? `aux antécédents suivants: \n ${antecedentsText}`
        : "sans antécédents particuliers."
    }
  
  
    Je vous la/le confie pour prise en charge.
  
    `;
  }